import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { TypographyRhythm } from '@jouzen/ecom-components/v3/TypographyRhythm';
import type { ComponentPropsWithoutRef, ReactNode } from 'react';
import type { MessageKey } from 'types/LocaleMessageKey';

import RichText from '@/app/components/RichText';

export interface SimpleTwoColumnModuleProps
  extends ComponentPropsWithoutRef<'section'> {
  readonly heading: {
    before?: ReactNode;
    content: MessageKey;
    after?: ReactNode;
  };
}

const SimpleTwoColumnModule = ({
  children,
  className = 'py-12',
  heading,
  ...props
}: SimpleTwoColumnModuleProps) => {
  return (
    <section {...props} className={className}>
      <LayoutGrid>
        <GridItem colEnd={{ sm: 'main', lg: 12 }} colStart={{ sm: 'main' }}>
          {heading.before}
          <Typography className="leading-tight" Element="h2" variant="h3">
            <RichText messageKey={heading.content} />
          </Typography>
          {heading.after}
        </GridItem>
        <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main', lg: 14 }}>
          <TypographyRhythm>{children}</TypographyRhythm>
        </GridItem>
      </LayoutGrid>
    </section>
  );
};

export default SimpleTwoColumnModule;
